"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _SARAALGAcjs = require('./SARAALGA.cjs');


var _MPIQVHCBcjs = require('./MPIQVHCB.cjs');


var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');





var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/disclosure/disclosure.tsx
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var TagName = "button";
var symbol = /* @__PURE__ */ Symbol("disclosure");
var useDisclosure = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useDisclosure2({ store, toggleOnClick = true, ...props }) {
    const context = _SARAALGAcjs.useDisclosureProviderContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "Disclosure must receive a `store` prop or be wrapped in a DisclosureProvider component."
    );
    const ref = _react.useRef.call(void 0, null);
    const [expanded, setExpanded] = _react.useState.call(void 0, false);
    const disclosureElement = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "disclosureElement");
    const open = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "open");
    _react.useEffect.call(void 0, () => {
      let isCurrentDisclosure = disclosureElement === ref.current;
      if (!(disclosureElement == null ? void 0 : disclosureElement.isConnected)) {
        store == null ? void 0 : store.setDisclosureElement(ref.current);
        isCurrentDisclosure = true;
      }
      setExpanded(open && isCurrentDisclosure);
    }, [disclosureElement, store, open]);
    const onClickProp = props.onClick;
    const toggleOnClickProp = _3BSDKDKDcjs.useBooleanEvent.call(void 0, toggleOnClick);
    const [isDuplicate, metadataProps] = _3BSDKDKDcjs.useMetadataProps.call(void 0, props, symbol, true);
    const onClick = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented) return;
      if (isDuplicate) return;
      if (!toggleOnClickProp(event)) return;
      store == null ? void 0 : store.setDisclosureElement(event.currentTarget);
      store == null ? void 0 : store.toggle();
    });
    const contentElement = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "contentElement");
    props = {
      "aria-expanded": expanded,
      "aria-controls": contentElement == null ? void 0 : contentElement.id,
      ...metadataProps,
      ...props,
      ref: _3BSDKDKDcjs.useMergeRefs.call(void 0, ref, props.ref),
      onClick
    };
    props = _MPIQVHCBcjs.useButton.call(void 0, props);
    return props;
  }
);
var Disclosure = _PTOCUU2Dcjs.forwardRef.call(void 0, function Disclosure2(props) {
  const htmlProps = useDisclosure(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useDisclosure = useDisclosure; exports.Disclosure = Disclosure;
